const KEY = 'app_user';

export function saveLocalUser(id, name, mask) {
    localStorage.setItem(KEY, JSON.stringify({id, name, mask}));
}

export function getLocalUser() {
    return JSON.parse(localStorage.getItem(KEY));
}

export function removeLocalUser() {
    localStorage.removeItem(KEY);
}
